// The AI pages need the AI backend and its database tables, so they stay hidden until both are in place.
// To show them, set REACT_APP_AI_FEATURES_ENABLED=true (GitHub variable for an environment, .env locally).
export const IS_AI_FEATURES_ENABLED =
  process.env.REACT_APP_AI_FEATURES_ENABLED === 'true';

export const AI_PROMPT_MAX_LENGTH = 20000;

export const AI_PROMPT_FEATURES = [
  {
    key: 'precisionConversation',
    type: 'PrecisionConversation',
    name: 'Precision Conversation',
    autoContext: [
      'Lead fields with values, labeled as vendor data, modeled estimate or area estimate',
      'The export date as the "as of" date of the data',
      'Call history for the lead: date and outcome of the last 10 calls',
    ],
    getRemoveEffect: clientName =>
      `Precision Conversation is turned off for ${clientName}. Callers get the current web-based customization.`,
    getRemovedMessage: clientName =>
      `Prompt removed. ${clientName} callers get the current web-based customization.`,
  },
  {
    key: 'precisionMeeting',
    type: 'PrecisionMeeting',
    name: 'Precision Meeting',
    autoContext: [
      'Call transcript by segment, with timestamps and speaker (caller or prospect)',
      "Booked meeting: date, time in the prospect's time zone, type and status; 30 minutes long by default (bookings have no length)",
      'Lead fields with values and the latest Precision Conversation brief',
      'Call history for the lead',
    ],
    getRemoveEffect: clientName =>
      `Precision Meeting is turned off for ${clientName}. The option is hidden in Playback and the Bookings Report.`,
    getRemovedMessage: clientName =>
      `Prompt removed. Precision Meeting is hidden for ${clientName}.`,
  },
];

export const AI_PROMPT_STATUS_FILTER = {
  ALL: 'all',
  ON: 'on',
  OFF: 'off',
};
